/** Ethiopia does not observe daylight saving; wall time is always UTC+3. */
const ADDIS_OFFSET = '+03:00';

/** ISO instant -> `yyyy-MM-ddTHH:mm` in Africa/Addis_Ababa, for datetime-local inputs. */
export function toAddisInput(iso: string): string {
  const parts = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Africa/Addis_Ababa',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23',
  }).formatToParts(new Date(iso));
  const get = (type: Intl.DateTimeFormatPartTypes) =>
    parts.find((part) => part.type === type)?.value ?? '';
  return `${get('year')}-${get('month')}-${get('day')}T${get('hour')}:${get('minute')}`;
}

/** datetime-local value, interpreted as Africa/Addis_Ababa, -> ISO string. */
export function fromAddisInput(value: string): string {
  return new Date(`${value}:00${ADDIS_OFFSET}`).toISOString();
}

export function addisDaysFromNow(days: number, hours = 18): string {
  const base = toAddisInput(new Date(Date.now() + days * 86_400_000).toISOString());
  const date = base.slice(0, 10);
  return `${date}T${String(hours).padStart(2, '0')}:00`;
}
